import { render, staticRenderFns } from "./historyPrice.vue?vue&type=template&id=08ae155c&scoped=true&"
import script from "./historyPrice.vue?vue&type=script&lang=js&"
export * from "./historyPrice.vue?vue&type=script&lang=js&"
import style0 from "./historyPrice.vue?vue&type=style&index=0&id=08ae155c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ae155c",
  null
  
)

export default component.exports